/*
    Сообщения приложения

    Типы:
    1. Предупреждения и уведомления. Отображаются в отдельном блоке страницы, на видном месте.
       Делятся на следующие группы по числовому коду:
        а. Предупреждения это критически важные для рабаты системы либо пользователя моменты,
           которые нельзя игнорировать. То есть сообщение нельзя "закрыть".
        б. Уведомления не носят критического характера и их можно "закрывать".
    2. Критическая ошибка. Отображается всегда в пределах текущей видимой области, сейчас снизу
       экрана. Реализовано отдельно в файле global-alert.js

       Сообщение выраженно следующим образом:
       {
            code: Number,
            message: String
       }
       Числовой код используется в функции "закрыть" и хранится в sessionStorage. Т.е. закрытые
       сообщения появятся снова, если закрыть и открыть окно.

       Деление сообщений по числовому коду:
       1000..1999 - Критически важные предупреждения
       2000..2999 - Игнорируемые предупреждения

       ToDo Передавать список закрытых сообщений в другое окно

       Пример подключения в main.js:

       import messages from '@/util/messages.js'
       Vue.prototype.$messages = messages

       На странице должен быть элемент с ref="app-msgs", например в App.vue:
       <section ref="app-msgs"></section>
 */

class ApplicationMessages {

    #initialized = false
    #enabled = false
    #critical = []
    #dismissible = []
    #closed = []

    constructor() {
        ///this.load()
    }
/*
    init() {
        if (!this.#initialized) {
            this.#initialized = true

            if (!document.getElementById('app-msgs')) {
                console.warn('Page need an element with ref="app-msgs" to use the messages module!')
            } else {
                this.#enabled = true
                var ComponentClass = Vue.extend(MessageView)
                this.viewInstance = new ComponentClass({
                    propsData: {
                        critical: this.#critical,
                        dismissible: this.#dismissible
                    }
                })
                this.viewInstance.$mount() // pass nothing
            }

            this.load()
        }
        return this.#initialized
    }
*/
    get critical() {
        return this.#critical
    }

    get dismissible() {
        return this.#dismissible
    }

    addAll(messages) {
        function push_new(_array, _message) {
            /* Только новые сообщения */
            let found = _array.find(item => item.code === _message.code)
            if (!found) {
                _array.push({
                    code: _message.code,
                    message: _message.message
                })
            }
        }

        messages.forEach(message => {
            if (message.code >= 1000 && message.code <= 1999) {
                push_new(this.#critical, message)
            } else if (message.code >= 2000 && message.code <= 2999) {
                push_new(this.#dismissible, message)
            }
        }, this)
        //this.init()
        ///this.save()
    }
/*
    save() {
        sessionStorage.messages = JSON.stringify({
            critical: this.#critical,
            dismissible: this.#dismissible,
            closed: this.#closed
        });
    }

    load() {
        function push_new(destination, source) {
            source.forEach(msg => {
                // Только новые сообщения
                let found = destination.find(item => item.code === msg.code)
                if (!found) {
                    destination.push(msg)
                }
            })
        }
        if (!sessionStorage.messages) return;
        let o = JSON.parse(sessionStorage.messages);
        push_new(this.#closed, o.critical)
        push_new(this.#critical, o.critical)
        push_new(this.#dismissible, o.dismissible)
    }
*/
    clear() {
        this.#closed.splice(0);
        this.#critical.splice(0)
        this.#dismissible.splice(0)
        //delete sessionStorage.messages
    }
}

const messages = new ApplicationMessages()

export default messages